import React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const ExternalLinkIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M8.6230319,2.23995266 L7.38307923,1 L10.999273,1 L10.999273,4.61619377 L9.75932034,3.3762411 C8.57561958,4.55954007 6.0643739,7.07078574 5.94222692,7.19333453 C5.62842166,7.50713979 5.11974373,7.50713979 4.80593847,7.19333453 C4.49213321,6.87952927 4.49213321,6.37085134 4.80593847,6.05704608 C4.92848726,5.9348991 7.43973293,3.42325162 8.6230319,2.23995266 Z M9.18159525,6.90938444 C9.18159525,6.65802765 9.38477154,6.45485137 9.63612832,6.45485137 C9.88748511,6.45485137 10.0906614,6.65802765 10.0906614,6.90938444 L10.0906614,10.0911159 C10.0906614,10.593375 9.68339976,11.0001821 9.18159525,11.0001821 L1.90906614,11.0001821 C1.40726163,11.0001821 1,10.593375 1,10.0911159 L1,2.81858681 C1,2.31632777 1.40726163,1.90952067 1.90906614,1.90952067 L5.09079763,1.90952067 C5.34169988,1.90952067 5.5453307,2.11269695 5.5453307,2.36405374 C5.5453307,2.61541053 5.34169988,2.81858681 5.09079763,2.81858681 L1.90906614,2.81858681 L1.90906614,10.0911159 L9.18159525,10.0911159 L9.18159525,6.90938444 Z"
        stroke={fillColor}
        strokeWidth="0.5"
        fill={fillColor}
      />
    </g>
  </svg>
);

export default ExternalLinkIcon;
